import React, { useState } from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import AuthService from '../../../business-api/AuthService'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem2xs6,
    GridItem2xs12,
    GridItem4xs12,
    GridItem6xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivBodyEntradaDados,
    CardGridEntradaDadosHeaderBodyDivider,
} from '../../../business-components/Card/Card'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    TextValidatorText,
    TextValidatorTextDestaque,
    TextValidatorTextMultiline,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelectRequired,
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import seguradoraList from '../../../business-rules/List/SeguroVida/seguradoraList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha,
    ButtonExcluirTabelaEvolucaoValorResgate,
    ButtonVisualizarTabelaEvolucaoValorResgate,
} from '../../../business-components/Button/Button'

import { 
    CustomizedDialogsPopup,
    CustomizedDialogsMensagem,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    CircularProgressPadrao,
} from '../../../business-components/CircularProgress/CircularProgress'

import {
    UploadFile,
} from '../../../business-components/UploadFile/UploadFile'

import {
    processaUploadAvulso,
} from '../integracaoClienteArquivo-list/IntegracaoClienteArquivoService'

import {
    processaAlteracaoSeguroVidaApoliceSeguradora,
} from '../seguroVida-form/SeguroVidaServiceSeguroVidaApolice'

import {
    incrementaContSeguroVidaCotacao,
    processaValoresDefaultIniciaisSeguroVidaCotacao,
} from './SeguroVidaCotacaoServiceCotacao'

import {
    incluiSeguroVidaCotacaoCoberturaDefault,
    excluirCotacaoCoberturas,
} from './SeguroVidaCotacaoServiceCobertura'

import SeguroVidaCotacaoFormCobertura from './SeguroVidaCotacaoFormCobertura'

import SeguroVidaCotacaoFormTabelaEvolucaoValorResgate from './SeguroVidaCotacaoFormTabelaEvolucaoValorResgate'


const SeguroVidaCotacaoFormCotacao = ({ variaveisGlobais, values, handleChange, setFieldValue, popupCotacao }) => {

    const [statusUpload, setStatusUpload] = useState(false)

    const [processing, setProcessing] = useState(false)

    const carregarTabelaEvolucaoValorResgate = async ( e, item, ind ) => {

        if (!AuthService.usuarioPrecisaLogarNovamente(variaveisGlobais)) {

            setProcessing(true)

            const { erros, listaErros } = await processaUploadAvulso(variaveisGlobais, values, item, e.target.files,
                LABEL.seguroVida + ' - ' + LABEL.cotacao)

            if (erros > 0) {

                setStatusUpload(
                    MESSAGE().statusIntegracaoAvulso
                        .replace("$1$", erros)
                            .replace("$2$", listaErros)
                )

            } else {

                setFieldValue(
                    `seguroVidaCotacao[${ind}].tabelaEvolucaoValorResgate`,
                    [...item.tabelaEvolucaoValorResgate],
                )
            }

            setProcessing(false)
        }
    }

    return (
        <FieldArray name="seguroVidaCotacao">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.seguroVidaCotacao?.map((item, ind) => {

                            processaValoresDefaultIniciaisSeguroVidaCotacao(item)
                            
                            return item.familiar === Number.parseInt(values.familiarSeguroVidaCotacao)
                            ? (
                                <GridItem12
                                    key={ind}
                                >
                                    {!popupCotacao && (
                                        <CardGridEntradaDados
                                            className='mb-5'
                                        >
                                            <GridContainer>
                                                <GridItem12
                                                    className='mt-2'
                                                    align='center'
                                                >
                                                    <h1>
                                                        {LABEL.cotacao}
                                                    </h1>
                                                </GridItem12>
                                            </GridContainer>
                                        </CardGridEntradaDados>
                                    )}

                                    <CardGridEntradaDados>
                                        <CardGridDivHeaderEntradaDados>
                                            <GridContainer>
                                                <GridItem2xs6>
                                                    <TextValidatorTextDestaque
                                                        name={`seguroVidaCotacao[${ind}].numeroCotacao`}
                                                        //placeholder={LABEL.numeroCotacao}
                                                        label={LABEL.numeroCotacao}
                                                        value={item.numeroCotacao|| ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.numeroCotacao}
                                                        disabled={item.tabelaEvolucaoValorResgate &&
                                                            item.tabelaEvolucaoValorResgate.length > 0
                                                        }
                                                    />
                                                </GridItem2xs6>

                                                <GridItem4xs12
                                                    className='mt-2'
                                                    align='center'
                                                >
                                                    {item.tabelaEvolucaoValorResgate &&
                                                    item.tabelaEvolucaoValorResgate.length > 0
                                                        ?
                                                            <ButtonExcluirTabelaEvolucaoValorResgate
                                                                onClick={() => {
                                                                    setFieldValue(
                                                                        `seguroVidaCotacao[${ind}].tabelaEvolucaoValorResgate`,
                                                                        [],
                                                                    )
                                                                }}
                                                            />
                                                        :
                                                            <UploadFile
                                                                id={"upload-arquivo-PDF" + ind}
                                                                label={LABEL.buttonUploadTabelaEvolucaoValorResgate}
                                                                accept=".pdf,.xlsx"
                                                                onChange={(e) => {
                                                                    carregarTabelaEvolucaoValorResgate(e, item, ind)
                                                                }}
                                                                multiple={false}
                                                                disabled={
                                                                    processing
                                                                }
                                                            />
                                                    }
                                                </GridItem4xs12>

                                                <GridItem4xs12
                                                    className='mt-2'
                                                    align='center'
                                                >
                                                    {item.tabelaEvolucaoValorResgate &&
                                                    item.tabelaEvolucaoValorResgate.length > 0 && (
                                                        <CustomizedDialogsPopup
                                                            maxWidth='md'
                                                            popupTitle={LABEL.tabelaEvolucaoValorResgate}
                                                            PopupButton={ButtonVisualizarTabelaEvolucaoValorResgate}
                                                            popupComponent={
                                                                <SeguroVidaCotacaoFormTabelaEvolucaoValorResgate
                                                                    values={values}
                                                                    item={item}
                                                                />
                                                            }
                                                        />
                                                    )}
                                                </GridItem4xs12>

                                                <GridItem2xs12>
                                                    <IconButtonClearEntradaDados
                                                        onClick={() => {
                                                            excluirCotacaoCoberturas(values, item.id)

                                                            arrayHelpers.remove(ind)
                                                        }}
                                                    />
                                                </GridItem2xs12>
                                            </GridContainer>

                                            {statusUpload
                                                ?
                                                    <CustomizedDialogsMensagem
                                                        confirmacaoTitle={LABEL.buttonUploadArquivos}
                                                        confirmacaoText={statusUpload}
                                                        onClick={() => {
                                                            setStatusUpload(false)
                                                        }}
                                                    />
                                                :
                                                    ''
                                            }

                                            {processing && (
                                                <CircularProgressPadrao />
                                            )}
                                        </CardGridDivHeaderEntradaDados>

                                        <CardGridDivBodyEntradaDados>
                                            <GridContainer>
                                                <GridItem2xs6>
                                                    <TextFieldNumberSelect
                                                        name={`seguroVidaCotacao[${ind}].seguradora`}
                                                        label={LABEL.seguradora}
                                                        value={item.seguradora || ''}
                                                        onChange={handleChange}
                                                        list={seguradoraList()}
                                                        onBlur={processaAlteracaoSeguroVidaApoliceSeguradora(item)}
                                                    />
                                                </GridItem2xs6>

                                                <GridItem2xs6
                                                    style={{
                                                        display:
                                                            item.seguradora === HARDCODE.idSeguradoraOutras 
                                                                ? "block"
                                                                : "none"
                                                    }}
                                                >
                                                    <TextValidatorText
                                                        name={`seguroVidaCotacao[${ind}].seguradoraOutras`}
                                                        label={LABEL.seguradoraOutras}
                                                        value={item.seguradoraOutras || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.seguradoraOutras}
                                                    />
                                                </GridItem2xs6>

                                                <GridItem2xs6>
                                                    <MuiPickersUtilsProviderPadrao>
                                                        <KeyboardDatePickerPadrao
                                                            name={`seguroVidaCotacao[${ind}].dataCotacao`}
                                                            label={LABEL.dataCotacao}
                                                            value={item.dataCotacao}
                                                            onChange={(date) => {
                                                                setFieldValue(
                                                                    `seguroVidaCotacao[${ind}].dataCotacao`,
                                                                    date,
                                                                )}
                                                            }
                                                        />
                                                    </MuiPickersUtilsProviderPadrao>
                                                </GridItem2xs6>

                                                <GridItem2xs6>
                                                    <TextFieldTextSelectRequired
                                                        name={`seguroVidaCotacao[${ind}].tipoPeriodicidadePagtoPremio`}
                                                        label={LABEL.tipoPeriodicidadePagtoPremio}
                                                        value={item.tipoPeriodicidadePagtoPremio || ''}
                                                        onChange={handleChange}
                                                        list={tipoPeriodicidadeList(false, true, false)}
                                                    />
                                                </GridItem2xs6>

                                                <GridItem6xs12
                                                    className='mt-2'
                                                >
                                                    <CheckboxPadrao
                                                        name={`seguroVidaCotacao[${ind}].utilizarApenasComparacaoPreco`}
                                                        label={LABEL.utilizarApenasComparacaoPreco}
                                                        checked={item.utilizarApenasComparacaoPreco}
                                                        onChange={handleChange}
                                                    />
                                                </GridItem6xs12>
                                            </GridContainer>

                                            <GridContainer>
                                                <GridItem12>
                                                    <TextValidatorTextMultiline
                                                        name={`seguroVidaCotacao[${ind}].observacao`}
                                                        label={LABEL.observacao}
                                                        value={item.observacao || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.observacao}
                                                    />
                                                </GridItem12>
                                            </GridContainer>
                                        </CardGridDivBodyEntradaDados>
                                        
                                        <CardGridEntradaDadosHeaderBodyDivider
                                            title={LABEL.coberturas}
                                        >
                                            <SeguroVidaCotacaoFormCobertura
                                                idSeguroVidaCotacao={item.id}
                                                integracao={item.integracao}
                                                values={values}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                            />
                                        </CardGridEntradaDadosHeaderBodyDivider>
                                    </CardGridEntradaDados>
                                </GridItem12>
                            )
                            :
                            (
                                ''
                            )
                        })}
                    </GridContainer>

                    <ButtonIncluirLinha
                        label={LABEL.buttonIncluirSeguroVidaCotacao} 
                        disabled={familiaresList(values).length === 0 || !values.familiarSeguroVidaCotacao ? true : false}
                        onClick={() =>
                            {
                                incrementaContSeguroVidaCotacao(values)
                                incluiSeguroVidaCotacaoCoberturaDefault (values, values.contSeguroVidaCotacao)
                                arrayHelpers.push({
                                    id: values.contSeguroVidaCotacao,
                                    familiar: Number.parseInt(values.familiarSeguroVidaCotacao),
                                })
                            }
                        }
                    />
                </DivForm>
            )}
        </FieldArray>
    )
}

export default SeguroVidaCotacaoFormCotacao